import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcAddressInputComponent } from './fc-address-input.component';

@NgModule({
  declarations: [
    FcAddressInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcAddressInputComponent
  ]
})
export class FcAddressInputModule { }
